import { Decorable } from '../../../types/decorable';
import { ICancellablePromise } from '../../../types/cancellable-promise';
import { ServerService } from 'app/model/services/api-services/server.service';
import { Injectable } from '@angular/core';
import { ProjectMetadata } from 'app/types/project-config';
import { PagingParams } from 'app/types/paging';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  constructor(private server: ServerService) { }

  GetAccountById(accountId?: string | number) {

    return this.server.Post('account/get', { account: accountId });
  }
  GetAccount(orgId: number) {
    const params: any = {};
    if (orgId > -1) {
      params.id = orgId;
    }
    return this.server.Post('account/get', params).then((response) => {
      if (response.status !== 'ok') {
        throw new Error(response.message);
      }
      if (!!response.account) {
        const account = response.account;
        const contact = response.contact;
        if (!!contact.created) {
          contact.created = new Date(contact.created);
        }
        if (!!contact.last_login) {
          contact.last_login = new Date(contact.last_login);
        }
        if (account.expires === '') {
          account.expires = undefined;
        } else {
          account.expires = new Date(account.expires);
        }
      }
      return response;
    }) as ICancellablePromise;
  }
  GetAccounts(paging?: PagingParams, term?: string): ICancellablePromise {
    const params: any = !!paging ? paging : {};
    if (!!term) params['term'] = term;
    return this.server.Post('account/list', params).then((response) => {
      if (response.status !== 'ok') {
        throw new Error(response.message);
      }
      return response;
    }) as ICancellablePromise
  }
}
